/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TimeRange } from './TimeRange';
import {
    TimeRangeFromJSON,
    TimeRangeFromJSONTyped,
    TimeRangeToJSON,
    TimeRangeToJSONTyped,
} from './TimeRange';

/**
 * Exception data
 * @export
 * @interface ScheduleExceptionRequest
 */
export interface ScheduleExceptionRequest {
    /**
     * 
     * @type {string}
     * @memberof ScheduleExceptionRequest
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleExceptionRequest
     */
    type?: ScheduleExceptionRequestTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof ScheduleExceptionRequest
     */
    scheduleId?: string;
    /**
     * 
     * @type {TimeRange}
     * @memberof ScheduleExceptionRequest
     */
    timeRange?: TimeRange;
    /**
     * 
     * @type {string}
     * @memberof ScheduleExceptionRequest
     */
    reason?: string;
    /**
     * 
     * @type {string}
     * @memberof ScheduleExceptionRequest
     */
    createdBy?: string;
    /**
     * 
     * @type {Date}
     * @memberof ScheduleExceptionRequest
     */
    createdAt?: Date;
    /**
     * 
     * @type {boolean}
     * @memberof ScheduleExceptionRequest
     */
    active?: boolean;
    /**
     * 
     * @type {{ [key: string]: any; }}
     * @memberof ScheduleExceptionRequest
     */
    metadata?: { [key: string]: any; };
}


/**
 * @export
 */
export const ScheduleExceptionRequestTypeEnum = {
    Cancellation: 'CANCELLATION',
    Modification: 'MODIFICATION',
    Replacement: 'REPLACEMENT',
    Extension: 'EXTENSION',
    Reduction: 'REDUCTION',
    Postponement: 'POSTPONEMENT',
    Advancement: 'ADVANCEMENT'
} as const;
export type ScheduleExceptionRequestTypeEnum = typeof ScheduleExceptionRequestTypeEnum[keyof typeof ScheduleExceptionRequestTypeEnum];


/**
 * Check if a given object implements the ScheduleExceptionRequest interface.
 */
export function instanceOfScheduleExceptionRequest(value: object): value is ScheduleExceptionRequest {
    return true;
}

export function ScheduleExceptionRequestFromJSON(json: any): ScheduleExceptionRequest {
    return ScheduleExceptionRequestFromJSONTyped(json, false);
}

export function ScheduleExceptionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): ScheduleExceptionRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'type': json['type'] == null ? undefined : json['type'],
        'scheduleId': json['scheduleId'] == null ? undefined : json['scheduleId'],
        'timeRange': json['timeRange'] == null ? undefined : TimeRangeFromJSON(json['timeRange']),
        'reason': json['reason'] == null ? undefined : json['reason'],
        'createdBy': json['createdBy'] == null ? undefined : json['createdBy'],
        'createdAt': json['createdAt'] == null ? undefined : (new Date(json['createdAt'])),
        'active': json['active'] == null ? undefined : json['active'],
        'metadata': json['metadata'] == null ? undefined : json['metadata'],
    };
}

export function ScheduleExceptionRequestToJSON(json: any): ScheduleExceptionRequest {
    return ScheduleExceptionRequestToJSONTyped(json, false);
}

export function ScheduleExceptionRequestToJSONTyped(value?: ScheduleExceptionRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'type': value['type'],
        'scheduleId': value['scheduleId'],
        'timeRange': TimeRangeToJSON(value['timeRange']),
        'reason': value['reason'],
        'createdBy': value['createdBy'],
        'createdAt': value['createdAt'] == null ? undefined : ((value['createdAt']).toISOString()),
        'active': value['active'],
        'metadata': value['metadata'],
    };
}

